<template>
  <div id="top-nav">
    <div class="topnav shadow-lg">
      <div class="container-fluid">
        <nav class="navbar navbar-light navbar-expand-lg topnav-menu">
          <div class="collapse navbar-collapse" id="topnav-menu-content">
            <ul class="navbar-nav">
              <li class="nav-item dropdown">
                <a
                  v-if="routesStartPath.startsWith('/index')"
                  class="nav-link dropdown-toggle arrow-none"
                  href="javascript:void(0)"
                  id="nav-platform-index"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  @click="platForm"
                >
                  总体概况
                </a>
              </li>
              <li class="nav-item dropdown">
                <a
                  v-if="routesStartPath.startsWith('/ability-framework')"
                  class="nav-link dropdown-toggle arrow-none"
                  href="javascript:void(0)"
                  id="nav-ability-framework-index"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  @click="abilityFramework"
                >
                  能力框架
                </a>
              </li>
              <li class="nav-item dropdown">
                <a
                  v-if="routesStartPath.startsWith('/ability-graph')"
                  class="nav-link dropdown-toggle arrow-none"
                  href="javascript:void(0)"
                  id="nav-ability-graph-index"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  @click="handleToAbilityGraph"
                >
                  图谱列表
                </a>
              </li>
            </ul>
            <!-- end navbar-->
          </div>
          <!-- end .collapsed-->
        </nav>
      </div>
      <!-- end container-fluid -->
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'SubNav',
  inject: ['reload'],
  data() {
    return {
      routepath: '',
    }
  },
  computed: {
    // onRoutes() {
    //   const path = this.$route.path
    //   // 在路由配置文件中设置自定义的路由路径到meta.activeMenu属性中，来控制菜单自定义高亮显示
    //   // meta中 有activeMenu 字段的子页面，都会显示高亮
    //   console.log('path:', path)

    //   return path
    // },

    // activeMenu() {
    //   const clickRoutes = this.$route
    //   console.log('clickRoutes', clickRoutes)
    //   const { meta, path } = clickRoutes

    //   if (meta.activeMenu) {
    //     return meta.activeMenu
    //   }
    //   return path
    // },
    ...mapState({
      userInfo(state) {
        return state.commom.userInfo
      },
      roleList(state) {
        return state.commom.roleList
      },
      routesStartPath() {
        // console.log('this.$route.path', this.$route.path)
        return this.$route.path
      },
    }),
    routesStartPath() {
      // console.log('this.$route.path', this.$route.path)
      return this.$route.path
    },
  },
  mounted() {},
  watch: {},
  methods: {
    refresh() {
      this.reload()
    },
    platForm() {
      this.$router.push({
        path: '/',
      })
    },
    attributeCourse() {
      this.$router.push({
        path: '/platform/attributeCourse',
      })
    },
    invalidCourse() {
      this.$router.push({
        path: '/platform/invalidCourse',
      })
    },
    accessAnalyse() {
      this.$router.push({
        path: '/platform/accessAnalyse',
      })
    },
    course() {
      this.$router.push({
        path: '/course',
      })
    },
    courseRank() {
      this.$router.push({
        path: '/course/courseRank',
      })
    },
    handleToAbilityGraph() {
      this.$router.push({
        path: '/ability-graph',
      })
    },
    supervision() {
      this.$router.push({
        path: '/supervision',
      })
    },
    courseStatistic() {
      this.$router.push({
        path: '/supervision/courseStatistic',
      })
    },
    teacherStatistic() {
      this.$router.push({
        path: '/supervision/teacherStatistic',
      })
    },
    studentStatistic() {
      this.$router.push({
        path: '/supervision/studentStatistic',
      })
    },
    abilityFramework() {
      this.$router.push({
        path: '/ability-framework/index',
      })
    },
    abilityCourse() {
      this.$router.push({
        path: '/ability-framework/course',
      })
    },
    isCourse() {
      if (this.routesStartPath === '/course') {
        return true
      } else {
        return false
      }
    },
    isSupervision() {
      if (this.routesStartPath === '/supervision') {
        return true
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped>
.navbar-light .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.7);
}
.nav-link.active {
  color: #ffffff !important;
  font-weight: bold;
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-left: 0 !important;
}
.topnav .navbar-nav .nav-item:first-of-type .nav-link {
  padding-left: 1.1rem;
}
</style>
